import { connect } from "react-redux";

import { requestWelcomeMessage } from "@template/state/modules/welcomeMessage/actions";
import { getPlatform } from "@template/state/modules/layout";
import { getSiteId } from "@template/state/modules/regionalStore";
import WelcomeMessage from "./WelcomeMessage";

const mapStateToProps = state => ({
  ...state.welcomeMessage,
  platform: getPlatform(state),
  siteId: getSiteId(state)
});

const mapDispatchToProps = {
  requestWelcomeMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeMessage);
